import React from "react";
import { Carousel } from "antd";
// import _bg3 from "../imgs/_black_white_1.jpeg";
import _bg3 from "../imgs/roger_orlando.jpeg";
import _bg2 from "../imgs/_black_white_2.jpeg";
// import _bg3 from "../imgs/_black_white_3.jpeg";
import _bg1 from "../imgs/blackbelts3.jpg";
import "./Slider.scss";

class Slider extends React.Component {
  constructor(props) {
    super(props);
    this.state = {};
  }
  componentDidMount() { }

  render() {
    return (
      <div className="slider">
        <Carousel autoplay autoplaySpeed={10500} dotClass="slider-dots">
          <div>
            <div className="slide" style={{ backgroundImage: `url(${_bg1})`, backgroundPosition: "top center" }}>
              <div className="container">
                <div className="bg-white">
                  <p>
                    The main focus is developing every single day the highest
                    level of teaching the most complex and effective martial art
                    and self defense already proved around the world , but also
                    sharing it towards seminars abroad and still finding his
                    time as an active very successful competitor.
                  </p>
                </div>
              </div>
            </div>
          </div>
          <div>
            <div className="slide" style={{ backgroundImage: `url(${_bg2})` }}>
              <div className="container">
                <div className="bg-white">
                  <p>
                    Since some years Orlando has been training frequently with his
                    old friend and best BJJ competitor of all time Roger Gracie. 
                    like that representing the Roger Gracie team in Austria,
                    but also keeping his roots having the support and visiting
                    often his masters in Rio and America, like that was build
                    the by far biggest and strongest team in austria and one of
                    the best in Europe as well.
                  </p>
                </div>
              </div>
            </div>
          </div>
          <div>
            <div className="slide" style={{ backgroundImage: `url(${_bg3})` }}>
              <div className="container">
                <div className="bg-white">
                  <p>
                    Having been established more than 12 years ago in Vienna, originally
                    named "O.Netobjj", his own team grew strongly and quickly.
                    After the first year of hard work it was clear the superiority of
                    the actual "Roger Gracie Austria". Top MMA fighters,
                    including a couple of UFC fighters have been trained by Orlando Neto.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </Carousel>
      </div>
    );
  }
}

export default Slider;
